import cn from 'classnames';

import { INews } from 'ApiPackage/NewsModule/interfaces/INews';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_SHORT } from 'CorePackage/MainModule/constants/dateFormat';
import { Accordion } from 'UIPackage/MainModule/components/Accordion';

import { formatFileSize } from '../common/formatFileSize';
import styles from './NewsItem.module.scss';

interface INewsItemProps {
  data: INews;
  locationMainPage?: boolean;
}

export const NewsItem = ({ data, locationMainPage }: INewsItemProps) => {
  const newsItemClassNames = cn(styles.NewsItem, {
    [styles.NewsItemTile]: locationMainPage,
    [styles.NewsItemRow]: !locationMainPage,
  });

  return (
    <div className={newsItemClassNames}>
      <h4 className={styles.Title}>{data.title}</h4>
      <div className={styles.Date}>{formatDate({ date: data.published || '', dateFormat: DATE_FORMAT_SHORT })}</div>
      <p className={styles.Text}>{data.shortText}</p>
      {!locationMainPage ? <Accordion content={data.text} /> : null}
      {data.files &&
        data.files.length !== 0 &&
        data.files.map(file => (
          <div key={file.id} className={styles.File}>
            <div className={styles.FileIcon} />
            <div className={styles.FileText}>
              <a className={styles.FileName} href={file.url} download={file.name}>
                {file.name}
              </a>
              <small className={styles.FileSize}>{formatFileSize(file?.size || 0)}</small>
            </div>
          </div>
        ))}
    </div>
  );
};
